var sourceMapToken = process.env.SOURCE_MAP_TOKEN;
document.cookie = sourceMapToken ? "sourceMapToken=".concat(sourceMapToken) : "sourceMapToken=".concat(sourceMapToken, ";;;expires=Thu, 01 Jan 1970 00:00:01 GMT\"");